/**
 * HR & Payroll permission keys (catalog `hr.*`, docs/contracts/hr-payroll.md §5). The API checks the same keys;
 * calculating and approving a payroll run are separate (HR24), and the approver must be a different user.
 */
/** Work record type of an employee (HR tasks, onboarding and exit forms; WK7). */
export const employeeRecordType = "hr.employee";

export const hrPermissions = {
  employeeView: "hr.employee.view",
  employeeCreate: "hr.employee.create",
  compensationView: "hr.employee_compensation.view",
  compensationUpdate: "hr.employee_compensation.update",
  personnelActionView: "hr.personnel_action.view",
  orgChartView: "hr.org_chart.view",
  attendanceDayView: "hr.attendance_day.view",
  attendanceDayCalculate: "hr.attendance_day.calculate",
  attendanceDayApprove: "hr.attendance_day.approve",
  attendanceDayLock: "hr.attendance_day.lock",
  punchImport: "hr.punch.import",
  leaveTypeView: "hr.leave_type.view",
  leaveRequestView: "hr.leave_request.view",
  leaveRequestCreate: "hr.leave_request.create",
  leaveRequestCancel: "hr.leave_request.cancel",
  leaveBalanceView: "hr.leave_balance.view",
  leaveBalanceUpdate: "hr.leave_balance.update",
  leaveBalanceRun: "hr.leave_balance.run",
  payrollMonthsView: "hr.payroll_months.view",
  payrollMonthsCreate: "hr.payroll_months.create",
  payrollRunView: "hr.payroll_run.view",
  payrollRunCreate: "hr.payroll_run.create",
  payrollRunCalculate: "hr.payroll_run.calculate",
  payrollRunApprove: "hr.payroll_run.approve",
  payrollRunPost: "hr.payroll_run.post",
  payrollRunPay: "hr.payroll_run.pay",
  payrollRunReverse: "hr.payroll_run.reverse",
  bankFileGenerate: "hr.payroll_bank_file.generate",
  payslipView: "hr.payslip.view",
  payslipPrint: "hr.payslip.print",
  loanView: "hr.loan.view",
  loanCreate: "hr.loan.create",
  loanDisburse: "hr.loan.disburse",
  hrRequestView: "hr.hr_request.view",
  hrRequestDelete: "hr.hr_request.delete",
  letterPrint: "hr.letter.print",
  selfServiceUse: "hr.self_service.use",
  settingsView: "hr.settings.view",
  settingsUpdate: "hr.settings.update",
  payrollConfigurationView: "hr.payroll_configuration.view",
  payrollConfigurationUpdate: "hr.payroll_configuration.update",
  leaveTypeCreate: "hr.leave_type.create",
  employeeUpdate: "hr.employee.update",
  identityView: "hr.employee_identity.view",
  identityUpdate: "hr.employee_identity.update",
  sensitiveView: "hr.employee_sensitive.view",
  sensitiveUpdate: "hr.employee_sensitive.update",
  personnelActionCreate: "hr.personnel_action.create",
  workScheduleView: "hr.work_schedule.view",
  workScheduleCreate: "hr.work_schedule.create",
  workScheduleUpdate: "hr.work_schedule.update",
  departmentSetupUpdate: "hr.department_setup.update",
  eosProvisionView: "hr.eos_provision.view",
  eosProvisionPost: "hr.eos_provision.post",
  leaveProvisionView: "hr.leave_provision.view",
  leaveProvisionPost: "hr.leave_provision.post",
} as const;

/** Plan module of HR & Payroll. */
export const hrModule = "hr";
